import { useState, type CSSProperties } from "react";
import type { OtpUiTexts } from "@codway-dev/shared";

type PreviewMode = "input" | "success" | "error";

const PREVIEW_MODES: PreviewMode[] = ["input", "success", "error"];

const linkButtonStyle: CSSProperties = {
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  color: "#2c6ecb",
  textDecoration: "underline",
  cursor: "pointer",
};

export function OtpWidgetLivePreview({ uiTexts }: { uiTexts: OtpUiTexts }) {
  const [mode, setMode] = useState<PreviewMode>("input");

  const description = uiTexts.description.replace(
    "{phone_number}",
    "+57 300 123 4567"
  );

  const nextMode = () => {
    const i = PREVIEW_MODES.indexOf(mode);
    setMode(PREVIEW_MODES[(i + 1) % PREVIEW_MODES.length]);
  };

  const icon =
    mode === "success"
      ? { type: "check-circle-filled" as const, tone: "success" as const }
      : mode === "error"
        ? { type: "x-circle" as const, tone: "critical" as const }
        : { type: "shield-check-mark" as const, tone: "neutral" as const };

  const heading =
    mode === "success"
      ? "¡Código correcto!"
      : mode === "error"
        ? "Código incorrecto"
        : uiTexts.title;

  const body =
    mode === "success"
      ? "Un momento, te estamos llevando a la siguiente pantalla."
      : mode === "error"
        ? uiTexts.invalid_code_error
        : description;

  const boxBorderColor =
    mode === "success" ? "#008060" : mode === "error" ? "#d72c0d" : "#c9cccf";

  return (
    <div style={{ position: "sticky", top: "16px" }}>
      <s-stack direction="inline" gap="small-200" alignItems="center">
        <s-text color="subdued">Vista previa</s-text>
        <div style={{ flex: 1 }} />
        <s-button onClick={nextMode}>Next Mode</s-button>
      </s-stack>

      <div
        style={{
          border: "1px solid #e1e3e5",
          borderRadius: "12px",
          padding: "24px",
          marginTop: "8px",
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        <s-icon type={icon.type} tone={icon.tone} />
        <h3 style={{ margin: "12px 0 8px", fontSize: "16px" }}>{heading}</h3>
        <p style={{ fontSize: "13px", color: "#6d7175", margin: "0 0 16px" }}>
          {body}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "6px",
            marginBottom: "16px",
          }}
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              style={{
                width: "32px",
                height: "40px",
                border: `1px solid ${boxBorderColor}`,
                borderRadius: "6px",
              }}
            />
          ))}
        </div>

        <button
          type="button"
          disabled={mode === "success"}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: mode === "success" ? "#8c9196" : "#202223",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontWeight: 600,
            marginBottom: "12px",
          }}
        >
          {uiTexts.verify_button}
        </button>

        <p style={{ fontSize: "12px", color: "#6d7175", margin: 0 }}>
          {uiTexts.hint_text}{" "}
          <button type="button" style={linkButtonStyle}>
            {uiTexts.resend_button}
          </button>{" "}
          o{" "}
          <button type="button" style={linkButtonStyle}>
            {uiTexts.change_phone_button}
          </button>
        </p>
      </div>
    </div>
  );
}
